$(document).ready(function(){

  var newsletterForm = $('.newsletterForm');
  newsletterForm.on('submit', function(e) {
    e.preventDefault();
    var data = $(this).serialize();
    // -- Remove any existing error messages from previous attempts --
    $('.form__notifications .msg').empty().fadeOut();

    $.ajax({
      type: 'post',
      url: '/',
      dataType: 'json',
      data: data,
      beforeSend: function(response) {
        newsletterForm.find('[type=submit]').prop('disabled', true);
      },
      success: function(response) {
      	console.log(response);
        if (response.success) {
          // -- Display notifications --
          $('.form__notifications .msg').text(response.message).delay(800).fadeIn();

        } else {
          // -- Display notifications --
          if (response.response != null || response.response != undefined) {
          	$('.form__notifications .msg').text(response.message + ': ' + response.response.detail).delay(400).fadeIn();
          } else {
          	$('.form__notifications .msg').text(response.message).delay(400).fadeIn();
          }
        }
      },
      error: function(response){
      	$('.form__notifications .msg').text(response.message).delay(400).fadeIn();
      },
      complete: function(response) {
        newsletterForm.find('[type=submit]').prop('disabled', false);
      }
    });

  });

});